(function () {
    'use strict';

    //  Adds Class to body element once DOM fully loaded. This will animate a few things in CSS.
    document.body.className += ' page-loaded';

})();